/** 
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Global filter table data component
  Date: April 25, 2020
**/

import React from 'react';

import { TextField, InputAdornment } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import { IconButton } from "@material-ui/core";
import ClearIcon from '@material-ui/icons/Clear'

const useStyles = makeStyles((theme) => ({
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
}));

const GlobalFilter = ({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) => {
  const classes = useStyles();
  const count = preGlobalFilteredRows.length;

  // Global filter only works with pagination from the first page.
  // This may not be a problem for server side pagination when
  // only the current page is downloaded.

  return (
    <div className={classes.search}>
      <TextField
        variant="outlined"
        size="small"
        InputProps={{
          'aria-label': 'search',
          /* startAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ), */
          endAdornment: (
            <>
              {globalFilter && <IconButton
                aria-label="clear"
                onClick={(e) => setGlobalFilter("")}
              ><ClearIcon style={{ fontSize: 14 }} /></IconButton>}
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            </>
          )
        }}
        style={{minWidth: '300px'}}
        value={globalFilter || ''}
        onChange={(e) => {
          setGlobalFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`${count} records...`}
        classes={{
          root: classes.inputRoot,
        }}
      />
    </div>
  );
};

GlobalFilter.propTypes = {
  preGlobalFilteredRows: PropTypes.array.isRequired,
  setGlobalFilter: PropTypes.func.isRequired,
};

export default GlobalFilter;
